module.exports = __webpack_public_path__ + "static/img/face9.37ede86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face9.jpg
// module id = 7/Gg
// module chunks = 0